import { NavLink } from 'react-router-dom';
import styles from './ErrorState.module.scss';

export const ErrorState = ({ title, message, linkText = 'На главную', linkUrl = '/' }) => {
  return (
    <section className={styles.error}>
      <div className="container">
        <div className={styles.error_body}>
          <h1 className={styles.error_title}>{title}</h1>
          <p className={styles.error_text}>{message}</p>
          <NavLink to={linkUrl} className={styles.error_link}>
            {linkText}
          </NavLink>
        </div>
      </div>
    </section>
  );
};
